import { easyCrypto } from '../../../sharpr/easyCrypto/easyCrypto.js';
import _ from 'lodash';

export function SsoAddRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SsoAdd', {
		url: '/admin/sso/add',
		controllerAs: 'vm',
		controller: SsoAddCtrl,
		templateUrl: '/ng/hub/Sso/Add/SsoAddCtrl.html?' + window.BUILD,
		permission: [],
		resolve: {
			$title: () => 'SsoAdd page',
		},
	});
}

export class SsoAddCtrl {
	constructor(Identity, Api) {
		'ngInject';
		// save injections
		this.Identity = Identity;
		this.Api = Api;
		// setup
		const hash = easyCrypto.randomString(6);
		this.spSuffix = `-${hash}-sp`;
		this.baseUrl = window.BASE_URL;
		this.data = {
			base_url: this.baseUrl,
			affiliation_id: Identity.currentAffiliationId(),
		};
	}

	async add() {
		try {
			if (this.data.auth_type === 'SAML') {
				if (!this.spPrefix) {
					throw Error('SP Code Prefix is required.');
				}
				this.data.sp_code = this.spPrefix + this.spSuffix;
			} else if (!this.data.sp_code) {
				throw Error('Friendly name is required.');
			}
			const spId = await this.Api.create('/sso/sps', this.data);
			if (spId) {
				window.location.href = `/hub#/admin/sso/sps/${spId}`;
			} else {
				throw new Error('Server error adding SSO');
			}
		} catch (e) {
			alert(e.message);
		}
	}
}
